
    import {computed, defineComponent, onMounted, reactive, ref, toRefs} from 'vue';
    import apiSetting from "@/request/apis/api_setting";
    import {message} from "ant-design-vue/es";
    import PageUtil from "@/utils/page_util";
    interface IState {
        list:any,
        searches:any,
        total:any,
        detailData:any,
        visible:any
    }

    export default defineComponent({
        name: 'salaryRange',
        components: {},
        setup() {
            let state: IState = reactive({
                list:[],
                searches:{
                    page_no:PageUtil.pageNo,
                    page_size:PageUtil.pageSize,
                    coupon_name:'',
                    goods_name:''
                },
                total:0,
                detailData:'',
                visible:false
            })

            const columns = [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    key: 'id',
                    align:'center'
                },
                {
                    title: '商品名称',
                    dataIndex: 'name',
                    key: 'name',
                    align:'center'
                },
                {
                    title: '商品图片',
                    dataIndex: 'image',
                    key: 'image',
                    align:'center'
                },
                {
                    title: '标价',
                    dataIndex: 'market_price',
                    key: 'market_price',
                    align:'center'
                },
                {
                    title: '最低价',
                    dataIndex: 'min_price',
                    key: 'min_price',
                    align:'center'
                },
                {
                    title: '最高价',
                    dataIndex: 'max_price',
                    key: 'max_price',
                    align:'center'
                },
                {
                    title: '拼团最低价',
                    dataIndex: 'team_min_price',
                    key: 'team_min_price',
                    align:'center'
                },
                {
                    title: '拼团最高价',
                    dataIndex: 'team_max_price',
                    key: 'team_max_price',
                    align:'center'
                },
                {
                    title: '店铺名称',
                    dataIndex: 'shop_name',
                    key: 'shop_name',
                    align:'center'
                },
                {
                    title: '店铺类型',
                    dataIndex: 'shop_type',
                    key: 'shop_type',
                    align:'center'
                },
                {
                    title: '状态',
                    dataIndex: 'status_text',
                    key: 'status_text',
                    align:'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    width: 250,
                    align:'center'
                },
            ];

            const getList = async () => {
                const params = {...state.searches}
                const res = await apiSetting.ActivityLists(params)
                if (res && res.error_code == 0) {
                    const data: any = res.data
                    state.list = data.lists
                    state.total = data.count
                }
            }

            const getDetail = async (val) => {
                const params = {id:val.id}
                const res = await apiSetting.ActivityDetail(params)
                if (res && res.error_code == 0) {
                    state.detailData = res.data
                    state.visible = true
                }
            }

            const getRecord = async (val) => {
                const params = {id:val.id}
                const res = await apiSetting.ActivityRecord(params)
                if (res && res.error_code == 0) {

                }
            }

            const pagination = computed(() => ({
                total: state.total,
                current: state.searches.page_no,
                pageSize: state.searches.page_size,
                showTotal: (total: any) => `共${total}条数据`,
                defaultPageSize: 10,
                // pageSizeOptions: ['5', '10', '15', '20'], // 可不设置使用默认
                showSizeChanger: true, // 是否启用pageSize选择
                showQuickJumper: true, // 是否显示跳转窗
            }));

            const handleTableChange = (pages: any) => {
                state.searches.page_size = pages.pageSize
                state.searches.page_no = pages.current
                getList()
            };
            onMounted(() => {
                getList()
            })

            return {
                ...toRefs(state),
                getList,
                getDetail,
                getRecord,
                columns,
                pagination,
                handleTableChange
            }
        }
    });
